export default {
	namespace: 'contact',
	beforeEnter() {

	},
	afterEnter( data ){
		console.log('View: contact')

		data.next.container.querySelectorAll('.input-resizer').forEach( resizer => {
			const control = resizer.querySelector('input, textarea')
			const dummy = resizer.querySelector('.dummy')

			const updateDummy = ()=> dummy.innerText = control.value || control.placeholder

			control.addEventListener('input', updateDummy)
			updateDummy()
		})

		data.next.container.querySelector('.input-resizer textarea').addEventListener('keypress', e => {
			if( e.key == 'Enter' ){ e.preventDefault() }
		})

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
